const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  // 中文注释：菜单权限列表（含 allowEdit）
  menuList: state => state.permission.menuList,
  // 中文注释：按菜单 name 快速索引权限
  menuMap: state => {
    const map = {};
    (state.permission.menuList || []).forEach(menu => {
      if (menu && menu.name) {
        map[menu.name] = menu;
      }
    });
    return map;
  }
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js